module.exports = __webpack_public_path__ + "static/media/news.05981c27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/news.svg
// module id = 287
// module chunks = 0